export default __webpack_public_path__ + "static/media/paymentTutorial_mobile_top_Cn.a78dc182.webp";